<template>
  <el-dialog
    title="签署设置"
    :visible="signSetVisi"
    width="35%"
    :close-on-click-modal="false"
    @close="closePup"
  >
    <el-form :model="formInItem" style="margin-top:20px">
<!--      api发起的，且没有authLevel意愿认证的默认值就不显示意愿认证-->
      <el-form-item label="意愿认证：" v-if="formInItem.signatoryUserType !== 2">
        <el-checkbox
          :true-label="11"
          :false-label="null"
          :checked="formInItem.authLevel === 11"
          v-model="formInItem.authLevel"
          >人脸识别</el-checkbox
        >
        <el-checkbox
          v-if="formInItem.signatoryUserType == 0"
          :true-label="12"
          :false-label="null"
          :checked="formInItem.authLevel === 12"
          v-model="formInItem.authLevel"
          >短信验证</el-checkbox
        >
      </el-form-item>
      <el-form-item
        label="签章设置："
        v-if="formInItem.signatoryUserType === 1"
      >
        <el-checkbox
          v-model="formInItem.extraHandSign"
          :true-label="1"
          :false-label="null"
          >经办人签字</el-checkbox
        >
      </el-form-item>
      <el-form-item label="强制阅读：">
        <el-checkbox v-model="formInItem.needRead"
          >需阅读
          <span @click.stop.prevent>
            <el-input-number
              v-model="formInItem.readTime"
              size="mini"
              :min="5"
              :max="300"
            ></el-input-number>
          </span>
          秒并阅读至合同末尾</el-checkbox
        >
      </el-form-item>
      <!-- <el-form-item
        label="签字设置："
        v-show="formInItem.signatoryUserType == 0"
      >
        <el-radio-group v-model="formInItem.signLevel">
          <el-radio :label="0">图形章</el-radio>
          <el-radio :label="1">手写签字</el-radio>
        </el-radio-group> -->

      <!-- <el-checkbox
          :true-label="10"
          :false-label="null"
          :checked="formInItem.signLevel === 0"
          v-model="signSet"
          @change="SignLevelChoose"
          >图形章</el-checkbox
        >
        <el-checkbox
          v-show="activeTabsName === signTypes[0]"
          :true-label="11"
          :false-label="null"
          :checked="formInItem.signLevel === 1"
          v-model="signSet"
          @change="SignLevelChoose"
          >手写签字</el-checkbox
        > -->
      <!-- </el-form-item> -->
      <el-form-item label="视频通话：" v-if="activeTabsName === signTypes[1]">
        <el-checkbox
          v-model="formInItem.faceOrVideo"
          :true-label="1"
          :false-label="null"
          :disabled="disOption({ faceOrVideo: formInItem.faceOrVideo })"
          @change="videoPartIn"
          >参与视频通话</el-checkbox
        >
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button size="small" @click="closePup">取 消</el-button>
      <el-button type="primary" size="small" @click="setConfirm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    signSetVisi: {
      type: Boolean,
      default: false
    },
    formInItem: {
      type: Object,
      default() {
        return {
          authLevel: false,
          needRead: false,
          readTime: 5,
          faceOrVideo: null,
          signatoryUserType: 1,
          signLevel: null,
          extraHandSign: null
        };
      }
    },
    signTypes: {
      type: Array,
      default() {
        return ["faceSign", "videoSign"];
      }
    },
    signatoryJson: { type: Array, default: [] },
    activeTabsName: String
  },
  data() {
    return {
      signSet: false // 签字设置 (图形章、图形签字)
    };
  },
  methods: {
    closePup() {
      this.$emit("PupConfirm", false);
      this.signSet = false;
    },
    setConfirm() {
      this.$emit("PupConfirm", this.formInItem);
      this.signSet = false;
    },
    videoPartIn(val) {
      this.$emit("videoPartIn", val);
    },
    disOption(item) {
      /** 视频签署情况下，
       * 四个视频参与方且 item.videoSignUserType!== 2， 视频通话选项禁用。
       */
      const json_arr = this.signatoryJson.filter(item => item.faceOrVideo == 1);
      return item.faceOrVideo != 1 && json_arr.length >= 4 ? true : false;
    },
    SignLevelChoose(val) {
      const signType = val === 10 ? 0 : val === 11 ? 1 : null;
      this.formInItem.signLevel = signType;
    }
  },
  watch: {
    formInItem(val) {
      console.log("formInItem", val);
    },
    "formInItem.signLevel": {
      handler(val) {
        this.signSet = val === 1 ? 11 : val === 0 ? 10 : null;
      }
    }
  },
  computed: {
    ...mapGetters(["currentAuthUser", "allAuthUser"])
  },
  mounted() {
    console.log("currentAuthUser", this.currentAuthUser);
  }
};
</script>

<style scoped lang="less"></style>



// WEBPACK FOOTER //
// pages/initiation/components/moreSetting.vue